<div id="iframe-parent" [ngClass]="{ iOS: iOS }">
  <iframe
    #iframe
    id="iframe-child"
    name="iframe-child"
    scrolling="yes"
    [src]="url | safeUrl"
    (load)="iframeOnLoad()"
  >
  </iframe>
</div>
